module.exports = "/_next/static/images/anthonyjardim-d3b0d1a6b6ec2f187c378f2a30082f92.jpg";